import React from 'react';
import './styles.scss';

const ToolbarSeparator = () => {
  return <div aria-orientation="vertical" className="up-toolbar-separator" role="separator" />;
};

export default ToolbarSeparator;
